import { Controller } from "@hotwired/stimulus"
import { attachOverflowCues } from "../lib/overflow_cues"

// Horizontal settings tab strip (shared/_tab_strip). Two jobs:
//
// 1. Centers the active tab on connect. The menu is a `nowrap` horizontal
//    scroller (see .gl-settings-tabs--horizontal), so on narrow viewports the
//    active tab can render off-screen when the page — or the Turbo frame —
//    loads. Scroll the strip itself (never the page) so the current tab is
//    always visible.
//
// 2. Toggles `has-overflow-left` / `has-overflow-right` on the strip so the
//    shell's edge-fade cues can signal clipped tabs (the gl-table-edge-cue
//    pattern, #5154, via the shared lib/overflow_cues attach — the Stimulus
//    counterpart of useHorizontalOverflowCues). The strip hides its scrollbar
//    to kill the Turbo-swap flash, so without the cues there is no affordance
//    at all that more tabs exist.
export default class extends Controller {
  connect() {
    this.centerActiveTab()
    this.detachOverflowCues = attachOverflowCues(this.element)
  }

  disconnect() {
    this.detachOverflowCues?.()
  }

  centerActiveTab() {
    // Cover every strip family this controller mounts on: settings strips
    // (shared/_tab_strip: .gl-settings-tab.active), plain gl-haml-tab strips
    // (Bootstrap tab/pill toggles: .active), and the React-idiom .is-active
    // spelling — a strip whose active class the selector misses silently
    // loses centering, never errors.
    const active = this.element.querySelector(
      ".gl-settings-tab.active, .gl-haml-tab.active, .gl-haml-tab.is-active",
    )
    if (!active) return

    // Nothing to do when the strip fits without scrolling (e.g. on desktop).
    if (this.element.scrollWidth <= this.element.clientWidth) return

    const offset = active.offsetLeft - (this.element.clientWidth - active.offsetWidth) / 2
    this.element.scrollLeft = Math.max(0, offset)
  }
}
